import React, { useState } from 'react';
import { Smile } from 'lucide-react';
import { Button } from './ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from './ui/popover';

const COMMON_EMOJIS = [
  '❤️', '😂', '😮', '😢', '😡', '👍', '👎', '🙏', '👏', '🔥',
  '✨', '💯', '🎉', '🤔', '😊', '😎', '🤗', '😍', '🥳', '😴',
  '🤩', '😇', '🤪', '😜', '🙃', '😌', '💪', '👌', '✌️', '🤝'
];

const EmojiPicker = ({ onSelect, trigger }) => {
  const [open, setOpen] = useState(false);

  const handleEmojiClick = (emoji) => {
    onSelect(emoji);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="icon" data-testid="emoji-picker-trigger">
            <Smile className="w-5 h-5" />
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-[260px] p-0" side="top" align="start" sideOffset={8} data-testid="emoji-picker-content">
        <div className="grid grid-cols-6 gap-0.5 p-2 max-h-[280px] overflow-y-auto">
          {COMMON_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              onClick={() => handleEmojiClick(emoji)}
              className="text-xl hover:bg-[#F1F5F9] rounded-lg p-1.5 transition-colors duration-150 flex items-center justify-center"
              data-testid={`emoji-${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default EmojiPicker;
